<template>
  <div>
    <div class="lp-edit-modal">
      <div class="lp-edit-title-text">Edit Pertanyaan</div>
      <div class="lp-edit-form">
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">ID</div>
          <div class="lp-edit-hiw-full">
            <input type="text" class="lp-edit-hiw-text" v-model="editData.name" disabled />
          </div>
        </div>
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">Tipe</div>
          <div class="lp-edit-hiw-multiple">
            <select class="lp-edit-hiw-select" v-model="editData.question_type"
              :disabled="editData.question_type === 'default'">
              <option value="default" disabled selected>Default</option>
              <option value="text">Text</option>
              <option value="textarea">Multiple Line Text</option>
              <option value="radio">Yes / No</option>
              <option value="date-picker">Date Picker</option>
              <option value="date-range">Date Start & Date End</option>
              <option value="attachment">Attachment</option>
            </select>
          </div>
        </div>
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">Mandatory</div>
          <div class="lp-edit-hiw-full">
            <input type="checkbox" class="lp-edit-hiw-checkbox" v-model="editData.is_mandatory" />
          </div>
        </div>
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">Teks</div>
          <div class="lp-edit-hiw-full">
            <textarea name="" id="" cols="30" rows="10" v-model="editData.text" class="lp-edit-hiw-text">
            </textarea>
          </div>
        </div>
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">Status</div>
          <div class="lp-edit-hiw-multiple">
            <select class="lp-edit-hiw-select" v-model="editData.is_active">
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
        </div>
        <p class="text-sm text-center">* Tipe Pertanyaan default/bawaan hanya dapat mengubah teks, mandatory dan status
        </p>
      </div>
      <div class="lp-button-container">
        <div class="lp-button-wrapper">
          <div class="lp-cancel-button" @click="closeModal">Cancel</div>
          <div class="lp-save-button" @click="saveEdit">Save</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'editData': Object,
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },

    async saveEdit() {
      await this.$store.dispatch('mdLandingStore/editForm', this.editData)
      this.closeModal()
    }
  }
}
</script>